export default __webpack_public_path__ + "static/media/punto-de-venta.bae93941.jpg";